module.exports = __webpack_public_path__ + "static/media/1.516215f4.png";